import React, { useState, useEffect } from 'react';
import {
   Card,
   Popover,
   PopoverHeader,
   PopoverBody,
   CardBody,
   CardTitle,
   Button,
   Table,
   Input, InputGroup, InputGroupAddon, InputGroupText, Form, Row, Col, FormGroup
} from 'reactstrap';
import { tokenHeader, getUserToken, getCurrentUser, getUsers } from "../../services/user-service";
import { getProspects, searchProspects, dateFormat, getAllProspects, getProspectsByUser,getType,getProspectsById } from '../../services/prospects';
import { getTemplates, getTemplatesById } from '../../services/template';
import { getNotes } from '../../services/notes';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TemplateModal from './template-modal';
import NotesModal from './notes-modal';
import { getUserData } from '../../services/dataService';
import {
   Modal, ModalHeader, ModalBody, Label
} from 'reactstrap';

import { sendBulkMailApi,apiCurrent } from '../../services/consts';
const apiEndPoint = sendBulkMailApi;

const Followup = (props) => {
   const [show, setShow] = useState(false);
   const [id, setId] = useState('');
   const [email, setEmail] = useState();
   const [currentId,setCurrentUserId] = useState('');
   const [sentByemail, setSentByEmail] = useState('');
   const [templateShow, setTemplateShow] = useState(false);
   const [loaded, setLoaded] = useState(false);
   const [prospects, setProspects] = useState([]);
   const [templates, setTemplates] = useState([]);
   const [templateById, setTemplateById] = useState('');
   // const [templateById, setTemplateById] = useState([]);
   const [loginLevel, setLoginLevel] = useState('');
   const [users, setUsers] = useState([]);
   const [prospectNotes, setProspectNotes] = useState([]);
   const [bilkId, setBulkId] = useState([]);
   const [tempId, setSelectedTemp] = useState();
   const [type, setTypeData] = useState();
   const [tempBody, setTempBody] = useState('');
   const [userName, setUserName] = useState();
   const [viewPros, setViewPros] = useState({});
   const [viewModal, setViewUserModal] = useState({ value: false });
   const viewToggle = () => setViewUserModal(!viewModal);
   var doClose = () => {
      // console.log(">>112")
      if (show == true) {
         setShow(false);
      }
      getProspectsData();
      // return false;
   }

   const typeData = [
      {value:"none",text:"None"},
      {value:"other",text:"Other"},
      {value:"transporter",text:"Transporter"},
      {value:"broker",text:"Broker"},
      {value:"IoT",text:"IoT"},
      {value:"MobiApp",text:"MobiApp"},
      {value:"IT",text:"IT"},
      {value:"BLE",text:"BLE"},
      {value:"PCB",text:"PCB"},
   ]
   
   var getProspectNotesData = (id) => {
      // console.log("id",props.status().id);
      getNotes(id).then((resProspectNotes) => {
         setProspectNotes(resProspectNotes);
         setId(id);
         setShow(true);
         // console.log("prospect notes", resProspectNotes);
      });
   }

   var setUserDetails = (id) => {
      getProspectsById(id).then((res)=>{
         setViewPros(res);
      })
    }

    const backtoProspectList = () =>{
      setViewUserModal({ value: false })
  }

   var showHideTemplate = (id, email) => {
      if (templateById === undefined || templateById === "") {
         toast.error('Please Select Email Template !!!');
      } else if (templateShow === true) {
         setTemplateShow(false);
      } else {
         setTemplateShow(true);
         setId(id);
         setEmail(email);
      }
   }

   var getTemplateData = () => {
      getTemplates().then((templates) => {
         // console.log("template",templates);
         setTemplates(templates);
      });
   }

   var getTemplateByIdData = (id) => {
      getTemplatesById(id).then((resTemplate) => {
         // setSelectedTemp(resTemplate.id);
         setTempBody(resTemplate.htmlBody);
         setTemplateById(resTemplate);
         // setTypeData(resTemplate.type);
      })
   }

   var getUsersData = () => {
      getUsers().then((users) => {
         setUsers(users);
      });
   }

   var doEdit = (id) => {
      props.history.push('/prospect/edit/' + id);
   }

   var ViewModalData = () => {
      return (
          <div>
              <Modal size="lg" isOpen={viewModal.value} toggle={viewToggle}>
                  <ModalHeader toggle={viewToggle}><span>View Prospect</span></ModalHeader>
                  <ModalBody>
                  <Form>
                        <Row>
                        <Col xl={6}>
                        <FormGroup>
                            <Label>Prospect Name</Label>
                            {viewPros !== undefined &&
                            <Input type="text" readOnly value={viewPros.name}/>}
                        </FormGroup>
                        </Col>
                        <Col xl={6}>
                        <FormGroup>
                            <Label>Company Name</Label>
                            {viewPros !== undefined &&
                            <Input type="text" readOnly value={viewPros.company}/>}
                        </FormGroup>
                        </Col>
                        </Row>

                        <Row>
                        <Col xl={6}>
                        <FormGroup>
                        <Label>Website Link</Label>
                            {viewPros !== undefined &&
                            <a href={viewPros.website} target="_blank">
                               <Input type="text" style={{cursor:"pointer"}} readOnly value={viewPros.website}/>
                            </a>
                            }
                        </FormGroup>
                        </Col>
                        <Col xl={6}>
                        <FormGroup>
                        <Label>Social Media Link</Label>
                            {viewPros !== undefined &&
                            <a href={viewPros.socialMediaLink} target="_blank">
                            <Input type="text" style={{cursor:"pointer"}} readOnly value={viewPros.socialMediaLink}/>
                         </a>}
                        </FormGroup>
                        </Col>
                        </Row>

                        <Row>
                        <Col xl={6}>
                        <FormGroup>
                            <Label>About Company</Label>
                            {viewPros !== undefined &&
                            <Input type="textarea" readOnly value={viewPros.aboutCompany}/>}
                        </FormGroup>
                        </Col>
                        <Col xl={6}>
                        <FormGroup>
                            <Label>Company Scope</Label>
                            {viewPros !== undefined &&
                            <Input type="textarea" readOnly value={viewPros.companyScope}/>}
                        </FormGroup>
                        </Col>
                        </Row>

                        {viewPros !== undefined &&
                        <Row>
                              <Col xl={6}>
                              <FormGroup>
                              <Label>Email (TO)</Label>
                              {viewPros !== undefined && viewPros.emailTO !== undefined
                              && <>
                              <Input readOnly style={{marginBottom:"10px"}} type="email" value={viewPros.emailTO == "" || viewPros.emailTO == null ? "-" : viewPros.emailTO.map(i=>{
                                 return i.to + "\n"
                               })} placeholder="Email" />
                              </>
                              }
                              </FormGroup>
                              </Col>
                              <Col xl={6}>
                              <FormGroup>
                              <Label>Email (CC)</Label>
                              {viewPros !== undefined && viewPros.emailCC !== undefined
                              && <>
                              <Input readOnly style={{marginBottom:"10px"}} type="email" value={viewPros.emailCC == "" || viewPros.emailCC == null ? "-" : viewPros.emailCC.map(i=>{
                                 return i.cc + "\n"
                               })} placeholder="Email" />
                              </>
                              }
                              </FormGroup>
                              </Col>
                        </Row>}
                        <Row>
                        <Col xl={6}>
                        <FormGroup>
                        <Label>City</Label>
                            {viewPros !== undefined &&
                            <Input type="text" readOnly value={viewPros.city}/>}
                        </FormGroup>
                        </Col>
                        <Col xl={6}>
                        <FormGroup>
                        <Label>State</Label>
                            {viewPros !== undefined &&
                            <Input type="text" readOnly value={viewPros.state}/>}
                        </FormGroup>
                        </Col>
                        </Row>

                        <Row>
                        <Col xl={6}>
                        <FormGroup>
                        <Label>Mobile No</Label>
                            {viewPros !== undefined &&
                            <Input type="text" readOnly value={viewPros.mobile}/>}
                        </FormGroup>
                        </Col>
                        <Col xl={6}>
                        <FormGroup>
                        <Label>Phones</Label>
                            {viewPros !== undefined &&
                            <Input type="text" readOnly value={viewPros.phones == null ? "-" : viewPros.phones}/>}
                        </FormGroup>
                        </Col>
                        </Row>

                        <Row>
                        <Col xl={6}>
                        <FormGroup>
                        <Label>Type</Label>
                            {viewPros !== undefined &&
                            <Input type="text" readOnly value={viewPros.type}/>}
                        </FormGroup>
                        </Col>
                        <Col xl={6}>
                        <FormGroup>
                        <Label>Industry</Label>
                            {viewPros !== undefined &&
                            <Input type="text" readOnly value={viewPros.industry}/>}
                        </FormGroup>
                        </Col>
                        </Row>

                        <Row>
                        <Col xl={6}>
                        <FormGroup>
                        <Label>Lead By</Label>
                            {viewPros !== undefined &&
                            <Input type="text" readOnly value={viewPros.leadBy}/>}
                        </FormGroup>
                        </Col>
                        <Col xl={6}>
                        <FormGroup>
                        <Label>Status</Label>
                            {viewPros !== undefined &&
                            <Input type="text" readOnly value={viewPros.status}/>}
                        </FormGroup>
                        </Col>
                        </Row>

                        <Row>
                        <Col xl={6}>
                        <FormGroup>
                        <Label>Assigned User</Label>
                            {viewPros !== undefined &&
                            <Input type="text" readOnly value={viewPros.assignedUser}/>}
                        </FormGroup>
                        </Col>
                        </Row>

                        <Row style={{float: "right"}}>
                      <Button onClick={backtoProspectList} className="btn-icon btn-2" type="button" color="info">
                              Close
                      </Button>
                      </Row>
                    </Form>
                  </ModalBody>
                  {/* <ModalFooter>
                      <Button color="success">
                          Submit
                      </Button>
                  </ModalFooter> */}
              </Modal>
          </div>);
  }

   var getProspectsData = () => {
      getProspects().then((prospects) => {
      //   console.log("prospects:>",prospects)
        prospects = prospects.filter((elm)=> elm.status == "Follow up")
         setProspects(prospects);
      });
   }

   var getAllProspectsData = () => {
      getAllProspects().then((prospects) => {
         // setSelectedTemp(prospects.id);
         // setTempBody(prospects.htmlBody);
         // setTypeData(prospects.type);
         // console.log("All prospects", prospects);
         prospects = prospects.filter((elm)=> elm.status == "Follow up")
         setProspects(prospects);
      })
   }

   var getProspectsByUserData = (assignedUser) => {
      getProspectsByUser(assignedUser).then((userProspects) => {
         // console.log("User's prospects",userProspects);
         // setSelectedTemp(userProspects.id);
         // setTempBody(userProspects.htmlBody);
         userProspects = userProspects.filter((elm)=> elm.status == "Follow up")
         setProspects(userProspects);
         // setTypeData(userProspects.type);
      })
   }

   var getProspectsByType = (typeData,userName) => {
      getType(typeData,userName).then((userType) => {
         // if(userType.length > 0){
         // setSelectedTemp(userType.id);
         // setTypeData(userType.type);
         // setTempBody(userType.htmlBody);
         setProspects(userType);
         // }
      })
   }

   var handleOnChangeTemplate = (e) => {
      if (e.target.value != "") {
         setSelectedTemp(e.target.value);
         getTemplateByIdData(e.target.value);
      }
   }

   var handleOnChangeProspects = (e) => {
         if (e.target.value == "all" && type == undefined) {
            setUserName(e.target.value)
            getAllProspectsData();
         }
         else if (e.target.value == "all" && type == "none") {
            setUserName(e.target.value)
            getAllProspectsData();
         }
         else if(e.target.value == "all" && type !== undefined){
            setUserName(e.target.value)
            // getAllProspectsData();
            getProspectsByType(type,e.target.value);
            // getProspectsByUserData(e.target.value);
         }
         else if(e.target.value == "all" && type == "none"){
            getAllProspectsData();
         }
          else if (e.target.value && type) {
            setUserName(e.target.value)
            getProspectsByType(type,e.target.value);
            // getProspectsByUserData(e.target.value);
         } else {
            setUserName(e.target.value)
            // getProspectsByType(type,e.target.value);
            getProspectsByUserData(e.target.value);
         }
   }

   var handleOnChangeType = (e) => {
      if (e.target.value !== "none") {
         setTypeData(e.target.value);
         // setUserName(userName);
         getProspectsByType(e.target.value,userName);
      }else{
         if(userName == "all" && e.target.value == "none"){
            setTypeData(e.target.value);
            // setUserName(userName);
            // setTypeData(e.target.value);
            getAllProspectsData();
         }
         else if(userName !== "all" && e.target.value == "none"){
            setTypeData(e.target.value);
            // if(type == undefined){
            //    console.log(type);
               // setUserName(userName);
               // setTypeData(e.target.value);
               getProspectsByUserData(userName)
            // }else{
            //    console.log(type);
            //    // setTypeData(e.target.value);
            //    getProspectsByType(e.target.value,userName);
            // }
         }
      }
   }
   
   var handleOnChange = (e) => {
      if (e.target.value != "") {
         searchProspects('search', e.target.value,userName).then((prospect) => {
            if (prospect != undefined) {
               // console.log("Search prospects ", prospects)
               setProspects(prospect);
            } else {
               // console.log("Prospects:" + JSON.stringify(prospect));
               setProspects([]);
            }
         });
      } else {
         if(getUserData() == userName){
            getProspectsData();
         }else if(userName == "all"){
            getAllProspectsData();
         }else{
            getProspectsByUserData(userName);
         }
         
      }
   }

   // var bulkMail = (e) => {
   //    const bulkDataMail = [];
   //    if((tempId === undefined && type === undefined)){
   //       toast.error('Please Select Email Template and Type !!!')
   //    }else if(tempId === undefined && type !== undefined){
   //       toast.error('Please Select Email Template !!!')
   //    }else if(tempId !== undefined && type === undefined){
   //       toast.error('Please Select Type !!!')
   //    }
   //    else{
   //    if(prospects.length > 0){
   //       var limitedMail = [];
   //       var limitedSuccess = [];
   //    for (let i = 0; i < prospects.length; i++) {
   //       if(prospects[i].email == null){
   //          limitedMail = prospects.filter((val,i)=>val.email == null)
   //       }else{
   //          console.log("templateById",templateById);
   //          limitedSuccess = prospects.filter((val,i)=>val.email)
   //       bulkDataMail.push({
   //             email: prospects[i].email,
   //             id: tempId,
   //             sentBy: sentByemail,
   //             subject:templateById.subject,
   //             htmlBody : tempBody + '<img src="https://leads.pyther.com/api/tracking/' + prospects[i].id + '/' + tempId  + '/photo/border.jpeg"/>'
   //       });
   //       }
   //    }
   //       if(limitedMail.length > 0){
   //          toast.info(limitedMail.length + " " + "email skipped !!");    
   //       }
   //       if(limitedSuccess.length > 0){
   //          e.preventDefault();
   //      let methodType = 'post';
   //      fetch(apiEndPoint, {
   //          method: methodType,
   //          body: JSON.stringify(bulkDataMail),
   //          headers: {
   //              'Accept': 'application/json',
   //              'Content-Type': 'application/json',
   //              [tokenHeader]: getUserToken()
   //          }
   //      }).then((result) => {
   //          toast.success(result.msg);
   //      })
   //      toast.success(limitedSuccess.length + " " + "email successfully sent !!");    
   //       }
   //    }else{
   //       toast.error('No Records Found !!!')
   //    }
   //    }
   // }

   useEffect(() => {
      if (!loaded) {
         // getAllProspectsData();
         getProspectsData();
         getTemplateData();
         getUsersData();
         setLoaded(true);
         getCurrentUser().then((result) => {
            if (result != null) {
               setCurrentUserId(result.id);
               setUserName(result.name);
               setLoginLevel(result.level);
               setSentByEmail(result.email);
            }
         })
      }
   });

   return (
      <div>
         <ViewModalData/>
         <ToastContainer
            position="top-right"
            autoClose={2000}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
         />
         <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
               <i className="mdi mdi-account-alert mr-2"></i>
            Follow up
          </CardTitle>
            <CardBody className="">
               <div className="ml-auto d-flex no-block align-items-center">
                  <Button color="success" onClick={() => {
                     props.history.push('/prospect/add');
                  }
                  }><i className="mdi mdi-account-multiple-plus mdi-18px"></i>&nbsp;&nbsp;Add Prospect</Button>&nbsp;&nbsp;&nbsp;
                  <div className="dl">
                     <InputGroup>
                        <InputGroupAddon addonType="prepend">
                           <InputGroupText><i className="fas fa-envelope"></i></InputGroupText>
                        </InputGroupAddon>
                        <Input type="select" className="custom-select" onChange={e => handleOnChangeTemplate(e)}>
                           <option hidden>Email Template</option>
                           {templates.map(item => item.type === "Email" ? (
                              <option value={item.id} key={item.id}>{item.slug}</option>
                           ) : '')}
                        </Input>
                     </InputGroup>
                  </div>&nbsp;&nbsp;&nbsp;
                  <div className="dl">
                     <InputGroup>
                        <InputGroupAddon addonType="prepend">
                           <InputGroupText><i className="fas fa-comment-dots"></i></InputGroupText>
                        </InputGroupAddon>
                        <Input type="select" className="custom-select" onChange={e => handleOnChangeTemplate(e)}>
                           <option hidden>Message Template</option>
                           {templates.map(item => item.type === "Message" ? (
                              <option key={item.id} value={item.id}>{item.slug}</option>
                           ) : '')}
                        </Input>
                     </InputGroup>
                  </div>&nbsp;&nbsp;&nbsp;
                     <div className="dl">
                     <InputGroup>
                        <InputGroupAddon addonType="prepend">
                           <InputGroupText><i className="fas fa-search"></i></InputGroupText>
                        </InputGroupAddon>
                        <Input type="search" name="search" placeholder="Search by name, email, company, assigned user, status" size="25"
                           onChange={e => handleOnChange(e)}
                        />
                     </InputGroup>
                  </div>&nbsp;&nbsp;&nbsp;
                     {loginLevel == 'Admin' && <div className="dl">
                     <InputGroup>
                        <InputGroupAddon addonType="prepend">
                           <InputGroupText><i className="fas fa-users"></i></InputGroupText>
                        </InputGroupAddon>
                        <Input type="select" className="custom-select" onChange={e => handleOnChangeProspects(e)}>
                           <option hidden>Show Prospects</option>
                           <option value="all">All</option>
                           {users.map(item => (
                              <option value={item.name} key={item.id}>{item.name}</option>
                           ))}
                        </Input>
                     </InputGroup>
                  </div>}
                  &nbsp;&nbsp;&nbsp;
                  {false && <div className="dl">
                     <InputGroup>
                        <InputGroupAddon addonType="prepend">
                           <InputGroupText><i className="fas fa-users"></i></InputGroupText>
                        </InputGroupAddon>
                        <Input type="select" className="custom-select" onChange={e => handleOnChangeType(e)}>
                           <option hidden>Show Types</option>
                           {typeData.map(item => (
                              <option value={item.value} key={item.value}>{item.text}</option>
                           ))}
                        </Input>
                     </InputGroup>
                  </div>}
                  {/* &nbsp;&nbsp;&nbsp;
                  {loginLevel == 'Admin' && <Button color="primary" size={"sm"} onClick={(e) => {
                     bulkMail(e)
                  }
                  }><i className="mdi mdi-email mdi-18px"></i>&nbsp;&nbsp;Bulk Mail</Button>} */}
               </div><br /><br />
               <Table style={{ tableLayout: 'fixed' }} striped bordered hover size="sm">
                  <thead>
                     <tr>
                        {/* <th style={{ width: '2rem' }}></th> */}
                        <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Name</th>
                        <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Company</th>
                        <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Email</th>
                        <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Mobile</th>
                        <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Industry</th>
                        <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Assigned</th>
                        <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Updated At</th>
                        <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Status</th>
                        {/* <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Followup Count</th> */}
                        <th style={{ width: '4rem' }}>Note</th>
                        <th style={{ width: '3rem' }}>Edit</th>
                        {/* <th style={{ width: '3rem' }}></th> */}
                        {/* <th style={{ width: '3rem' }}></th> */}
                     </tr>
                  </thead>
                  <tbody>
                     {prospects.length > 0 ? prospects.map(item => (
                        <tr key={item.id} >
                           {/* <td style={{ textAlign: 'center', color: 'blue' }}>
                              <input type="checkbox" onClick={() => { setBulkId(item.id) }}>
                              </input>
                           </td> */}
                           <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap',color:"#5e72e4" }}>
                              <a style={{cursor:"pointer"}} onClick={()=>{setViewUserModal({ value: true }); setUserDetails(item.id)}}>
                              <u>{item.name ? item.name : '-'}</u>
                              </a>
                           </td>
                           <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                              {item.company ? item.company : '-'}
                           </td>
                           <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'pre' }}>
                              {item.emailTO == null || item.emailTO == "" ? "-" : item.emailTO.map(i=>{
                                 if(i.to !== ""){
                                    return i.to + "\n"
                                 }else{
                                    return "-"
                                 }
                              })}
                           </td>
                           <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                              {item.mobile ? item.mobile : '-'}
                           </td>
                           <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                              {item.type ? item.type : '-'}
                           </td>
                           <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                              {item.assignedUser ? item.assignedUser : '-'}
                           </td>
                           <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                              {item.createdAt ? dateFormat(item.updatedAt) : '-'}
                           </td>
                           {/* {item.emailTO[0].to !== "" && item.emailTO[0].to !== null ?
                              <td style={{ textAlign: 'center' }}>
                                 <i style={{ color: 'blue',cursor:"pointer"}} className="mdi mdi-email mdi-24px"
                                    onClick={() => { showHideTemplate(item.id, item.emailTO) }}></i>
                              </td>
                              :
                              <td style={{ textAlign: 'center' }}>
                                 <i title="No Email Found" style={{ color: 'blue', opacity: '0.4', cursor: 'not-allowed' }} className="mdi mdi-email mdi-24px"></i>
                              </td>
                           } */}
                           <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                              {item.status ? item.status : '-'}
                           </td>
                           {/* <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                              {item.followUpCount ? item.followUpCount : '-'}
                           </td> */}
                           <td style={{ textAlign: 'center', fontSize:"23px" }}>
                              <span  className={
                             item.notes === "New" ? "newDot" : "" || item.notes === "Reference"
                             ? "referenceDot" : ""
                             || item.notes === "Followup"
                             ? "followupDot" : ""
                             || item.notes === "Close"
                             ? "closeDot" : ""
                             || item.notes === "Future"
                             ? "futureDot" : ""
                             || item.notes === "Interested"
                             ? "interestedDot" : ""
                             || item.notes === "Not Interested"
                             ? "notInterestedDot" : ""
                             || item.notes === null
                             ? "newDot" : ""}
                        ></span>
                        <i style={{cursor:"pointer", color: 'blueviolet', marginLeft: "3px"}} className="mdi mdi-clipboard-text mdi-24px"
                                 onClick={() => {
                                    getProspectNotesData(item.id);
                                 }}></i>
                           </td>
                           {/* <td style={{ textAlign: 'center', color: 'blueviolet' }}>
                           </td> */}
                           <td style={{ textAlign: 'center', color: 'blue' }}>
                              <i style={{cursor:"pointer"}} className="mdi mdi-pencil-circle mdi-24px" onClick={() => { doEdit(item.id) }}></i>
                           </td>
                           {/* {item.mobile !== "" && item.mobile !== null ?
                              <td style={{ textAlign: 'center' }}>
                                 {templateById === undefined || templateById === "" ?
                                    <span onClick={() => { toast.error("Please Select message template !!!") }}><i style={{ cursor:"pointer", color: '#25D366', marginTop: '5px' }} className="fab fa-whatsapp-square fa-2x"></i></span>
                                    :
                                    <a href={`https://api.whatsapp.com/send?phone=91${item.mobile}&text=Hello ${item.name},${templateById.textBody}`} target="_blank">
                                       <i style={{ cursor: 'not-allowed',color: '#25D366', marginTop: '5px' }} className="fab fa-whatsapp-square fa-2x"></i>
                                    </a>
                                 }
                              </td>
                              :
                              <td style={{ textAlign: 'center' }}>
                                 <i title="No Mobile Found" style={{ color: '#25D366', marginTop: '5px', opacity: '0.4', cursor: 'not-allowed' }} className="fab fa-whatsapp-square fa-2x"></i>
                              </td>
                           } */}
                        </tr>
                     )) : <tr><td colSpan={12} style={{ textAlign: 'center' }}><b>No Data Available</b></td></tr>}
                  </tbody>
               </Table>
            </CardBody>
         </Card>
         <NotesModal status={() => { return { show: show, id: id, prospectNotes: prospectNotes } }} visibileModal={() => { doClose() }} />
         <TemplateModal prospectID={() => { return { id: id, email: email,currentUser:currentId } }} templateStatus={() => { return { templateShow: templateShow } }} showTemplate={() => { return { templateById: templateById } }} trackMail={window.location.href.startsWith("http://localhost") ? '<img src="'+apiCurrent+'api/tracking/' + id +'/' + tempId + '/photo/border.jpeg"/>' : '<img src="'+apiCurrent+'api/tracking/' + id +'/' + tempId + '/photo/border.jpeg"/>'} visibileTemplateModal={() => { showHideTemplate() }} />
      </div>
   );
}

export default Followup;